import { render } from "./LanguagesPopover.vue?vue&type=template&id=4465b60a"
import script from "./LanguagesPopover.vue?vue&type=script&lang=js"
export * from "./LanguagesPopover.vue?vue&type=script&lang=js"

import "./LanguagesPopover.vue?vue&type=style&index=0&id=4465b60a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__